import { OneXTwoEnum } from "../../Enums/ValueEnums";

export default class ValueOneXTwo {
    public value: OneXTwoEnum = null;
}